import { IFinalEvent } from "types/event"

export function EventMinPrice(event: IFinalEvent):
    | {
          minPrice: number
          discount: { current_value: number; previous_value: number }
      }
    | undefined
    | unknown {
    try {
        let discount
        let minPrice

        if (event?.availableTickets?.length > 0) {
            minPrice = event?.availableTickets[0]?.price
            discount = event?.availableTickets[0]?.discount

            return { minPrice, discount }
        } else {
            return {
                minPrice: 0,
                discount: { current_value: 0, previous_value: 0 },
            }
        }
    } catch (err) {
        return err
    }
}

export function isEventExpired(event: IFinalEvent) {
    const today = new Date()
    const eventDate = new Date(event?.event_date?.ending_date)
    const result = today > eventDate
    return result
}
